import styled from "styled-components";

export const SimpleDefaultModal = styled.div`
  position: fixed;
  inset: 0;
  background: color-mix(in srgb, var(--brand-navy, #00212d) 52%, transparent);
  backdrop-filter: blur(6px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  overflow-y: auto;
  padding: 1rem;
`;

export const ModalContent = styled.div`
  position: relative;
  background: var(--surface-1);
  color: var(--text-primary);
  padding: 1.5rem;
  border-radius: 18px;
  border: 1px solid var(--border-subtle);
  box-shadow: var(--shadow-lg);
  z-index: 10000;
  width: min(100%, 360px);
  overflow-y: auto;
  max-height: min(90vh, 600px);

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: var(--brand-cta-gradient-135);
  }

  h4 {
    color: var(--text-heading);
    margin-top: 0.25rem;
  }
`;
